module.exports = __webpack_public_path__ + "static/media/GoalSetting.ce83b675.mp3";